import React, { useEffect, useState } from "react";
import AdvertDashboardLayout from "../../pages/ResponsiveAdvertiserDashboard/ResponsiveAdvertiserDashboardLayout/AdvertDashboardLayout";
import CardOne from "../../assets/icons/card.svg";
import CardTwo from "../../assets/icons/card-two.svg";
import { CheckIcon, useDisclosure } from "@chakra-ui/icons";
import End2EndIcon from "../../assets/icons/end2end.svg";
import {
  GET_CAMPAIGN_SUMMARY_FROM_DRAFT,
  GET_SUPPORTED_CURRENCIES,
} from "../GraphQL/Queries";
import { getCountyByCurrency } from "../../utils/functions";
import { useParams } from "react-router-dom";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { CREATE_CAMPAIGN } from "../GraphQL/Mutation";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { useFormatAmount } from "../../hook";
import CurrencyPopover from "../../bookCampaign/components/CurrencyPopover";
import { Loader } from "../Spinner/Loader";

const CampaignDigitalCheckout = () => {
  const [paymentMethod, setPaymentMethod] = useState("Paystack");
  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const [campaignSummary, setCampaignSummary] = useState(null);

  const currency = localStorage.getItem("currency") ?? "USD";

  const { data, loading: isLoadingCurrency } = useQuery(
    GET_SUPPORTED_CURRENCIES
  );

  const [selectedCurrency, setSelectedCurrency] = useState(
    data?.guest?.getSupportedCurrencies[0] ?? {
      currency: currency,
      country: getCountyByCurrency(currency),
    }
  );

  const [nextCurrency, setNextCurrency] = useState(selectedCurrency);

  const end2EndPay = window.End2EndPAY;

  // get draftId from url params
  const params = useParams();

  const { onOpen, onClose, isOpen } = useDisclosure();

  const formatAmount = useFormatAmount;

  const [getCampaignSummaryFromDraft, campaignSummaryFromDraft] = useLazyQuery(
    GET_CAMPAIGN_SUMMARY_FROM_DRAFT
  );

  const [campaign, { loading }] = useMutation(CREATE_CAMPAIGN, {
    context: {
      headers: {
        "apollo-require-preflight": true,
      },
    },
    async onCompleted(data) {
      const result = data.advertiser.createCampaign;

      switch (result.paymentMethod) {
        case "Paystack":
          // redirect to paystack payment page
          window.location.href = result.authorizationUrl;
          break;

        case "End2End":
          end2EndPay.init(
            result.apiKey,
            result.accessKey,
            result.amount,
            result.currency,
            result.callbackUrl,
            result.userEmail,
            result.referenceId
          );
          end2EndPay.getPaymentForm();
          break;

        case "Wallet":
          if (result.result === true) {
            toast.success("Payment successful");
            onOpen();
            // navigate('/dashboard/station')
          }
          break;

        default:
          // Wallet
          console.log(result);
          break;
      }
    },

    onError: (error) => {
      toast.error(error?.networkError?.result?.errors[0]?.message);
    },
  });

  const HandleGetDraft = () => {
    setIsLoadingDraft(true);
    getCampaignSummaryFromDraft({
      variables: {
        draftId: params.draftId,
        currency: selectedCurrency?.currency,
      },
    })
      .then((result) => {
        if (result?.data?.advertiser?.getCampaignSummaryFromDraft) {
          setCampaignSummary(
            result.data.advertiser.getCampaignSummaryFromDraft
          );
        }
        setSelectedCurrency(nextCurrency);
        localStorage.setItem("currency", nextCurrency?.currency);
        setTimeout(() => {
          setIsLoadingDraft(false);
        }, 5000);
      })
      .catch((error) => {
        // Handle the error here (e.g., show a notification or log it)
        // console.error("Error fetching campaign summary:", error);
        setTimeout(() => {
          setIsLoadingDraft(false);
        }, 5000);
        toast.error("Error in converting to selected currency");
      });
  };

  useEffect(() => {
    if (selectedCurrency) {
      HandleGetDraft();
    }
  }, [selectedCurrency]);

  useEffect(() => {
    // Get campaign summary from localhost or server
    const tempCampaignSummary = JSON.parse(
      localStorage.getItem("campaignSummary")
    );

    if (
      tempCampaignSummary &&
      tempCampaignSummary.advertiser.createDraft.id === params.draftId
    ) {
      setCampaignSummary(tempCampaignSummary.advertiser.createDraft.summary);
    } else {
      getCampaignSummaryFromDraft({
        variables: {
          draftId: params.draftId,
          currency: selectedCurrency?.currency,
        },
      });
    }

    if (campaignSummaryFromDraft.data)
      setCampaignSummary(
        campaignSummaryFromDraft.data.advertiser.getCampaignSummaryFromDraft
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignSummaryFromDraft.data]);

  const submitCampaign = () => {
    // track user event
    mixpanel.track("make_payment");

    campaign({
      variables: {
        input: {
          checkoutPageUrl: `${window.location.origin}/book-campaign/success`,
          currency: selectedCurrency?.currency,
          draftId: params.draftId,
            name: campaignSummary?.digitalCampaignSummary?.name,
          paymentMethod: paymentMethod,
        },
      },
    });
  };

  function formatNumber(num) {
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1) + "B";
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "K";
    }
    return num;
  }

  return (
    <>
      <div
        id="end2endContainer"
        style={{
          width: "100%",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: "1000",
          background: "white",
        }}
      ></div>
      <AdvertDashboardLayout>
      {isLoadingDraft  && (
            <Loader
              description={`${
                 !isLoadingDraft
                  ? "File is Uploading..."
                  : "Converting Currency ..."
              }`}
            />
          )}
        <div className="digital-checkout">
          <div>
            <h1>Checkout</h1>
            <h4 className="card-option-wrapper">
              Select your preffered payment method
            </h4>
          </div>
          <div className="checkout-wrapper">
            <div className="payment-card-wrapper">
              <div
                className={
                  paymentMethod === "Paystack" ? "active__payment-type" : ""
                }
                onClick={() => setPaymentMethod("Paystack")}
              >
                <div style={{ position: "relative" }}>
                  <img src={CardTwo} alt="paystack-icon" />
                  <div
                    className={
                      paymentMethod === "Paystack"
                        ? "payment__check-icon"
                        : "hide__check-icon"
                    }
                  >
                    <CheckIcon boxSize={4} color="#f1613f" />
                  </div>
                </div>
                <span className="card-type-wrapper">PAY WITH PAYSTACK</span>
              </div>
              <div
                className={
                  paymentMethod === "End2End" ? "active__payment-type" : ""
                }
                onClick={() => setPaymentMethod("End2End")}
              >
                <div style={{ position: "relative" }}>
                  <img src={End2EndIcon} alt="end2end-icon" />
                  <div
                    className={
                      paymentMethod === "End2End"
                        ? "payment__check-icon"
                        : "hide__check-icon"
                    }
                  >
                    <CheckIcon boxSize={4} color="#F99B28" />
                  </div>
                </div>
                <span className="card-type-wrapper">PAY WITH END2END</span>
              </div>
              <div
                className={
                  paymentMethod === "Wallet" ? "active__payment-type" : ""
                }
                onClick={() => setPaymentMethod("Wallet")}
              >
                <div style={{ position: "relative" }}>
                  <img src={CardOne} alt="wallet-icon" />
                  <div
                    className={
                      paymentMethod === "Wallet"
                        ? "payment__check-icon"
                        : "hide__check-icon"
                    }
                  >
                    <CheckIcon boxSize={4} color="#F99B28" />
                  </div>
                </div>
                <span className="card-type-wrapper">PAY FROM WALLET</span>
              </div>
            </div>
          </div>
          <div className="order-digital-summary">
            <h3>Order Summary</h3>
            <div className="summary-item">
              <span>{campaignSummary?.campaignSummary[0].name}</span>
              <span>{formatNumber(campaignSummary?.digitalCampaignSummary?.impressions)} Impressions</span>
            </div>
            <div className="summary-item">
              <span>Subtotal</span>
              <span>{formatAmount(campaignSummary?.subTotal)}</span>
            </div>
            <div className="summary-item">
              <span>VAT 7.5%</span>
              <span>{`${
                isLoadingDraft ? "...." : formatAmount(campaignSummary?.vat)
              }`}</span>
            </div>
            <div className="summary-item total">
              <span>
                Total
                {/* <CurrencyPopover
                  loading={loading || isLoadingCurrency}
                  selectedCurrency={selectedCurrency}
                  setSelectedCurrency={setSelectedCurrency}
                  HandleGetDraft={HandleGetDraft}
                  currencies={data?.guest?.getSupportedCurrencies}
                  updateFromFunc={true}
                  p={2}
                  flagr={0.5}
                  setNextCurrency={setNextCurrency}
                  adjustArrow={true}
                /> */}
              </span>
              <span className="total-amount">
                {`${
                  isLoadingDraft
                    ? "..."
                    : formatAmount(campaignSummary?.grandTotal)
                }`}
              </span>
            </div>

            <div className="ad-footer-btn">
              <div className="ad-footer-info ad-action-wrapper">
                {/* <h2>cancel</h2> */}
                <button
                  onClick={()=> submitCampaign()}
                >
                  {loading ? (
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  ) : (
                    <p className="continue">continue</p>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </AdvertDashboardLayout>
    </>
  );
};

export default CampaignDigitalCheckout;
